import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import _isUndefined from 'lodash/isUndefined';

import {withStyles} from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';

import {
  ButtonResetEntity,
} from '../index';

import style from '../../styles/components/cards';

function EntityResettingCard(props) {
  const {
    classes,
    content,
    customCardClass,
    customCardContentClass,
    handleClickButtonReset,
    isResetAvailable,
    title,
    isFullscreen,
    entityType,
  } = props;

  const headerClasses = {
    root: classes.card__header,
    title: `${classes.card__title} ${classes.card__title_edit}`,
    action: classes.card__actions_edit,
  };

  return (
    <Card
      className={classNames(
        classes.card,
        {
          [classes.card_fullScreen]: isFullscreen,
          [classes[customCardClass]]: !_isUndefined(customCardClass),
        },
      )}
    >
      <CardHeader
        classes={headerClasses}
        title={title}
        action={(
          <ButtonResetEntity
            customClasses="cardActions__button"
            disabled={!isResetAvailable}
            entityType={entityType}
            onClick={handleClickButtonReset}
          />
        )}
      />
      <CardContent
        className={classNames(
          classes.card__content,
          {
            [classes[customCardContentClass]]: !_isUndefined(customCardContentClass),
          },
        )}
      >
        {content}
      </CardContent>
    </Card>
  );
}

EntityResettingCard.propTypes = {
  classes: PropTypes.object.isRequired,
  content: PropTypes.node,
  customCardClass: PropTypes.string,
  customCardContentClass: PropTypes.string,
  handleClickButtonReset: PropTypes.func,
  isResetAvailable: PropTypes.bool,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  isFullscreen: PropTypes.bool,
  entityType: PropTypes.string,
};

EntityResettingCard.defaultProps = {
  content: '',
  customCardClass: undefined,
  customCardContentClass: undefined,
  handleClickButtonReset: () => {},
  isResetAvailable: true,
  title: '',
  isFullscreen: true,
  entityType: '',
};

export default withStyles(style)(EntityResettingCard);
